import type { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

// `action`: optional page-specific way out (e.g. a PRD access request),
// rendered above the homepage link.
const Page403 = ({ action }: { action?: ReactNode }) => {
  return (
    <section className="bg-background">
      <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
        <div className="mx-auto max-w-screen-sm text-center">
          <h1 className="mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-primary">
            403
          </h1>
          <p className="mb-4 text-3xl tracking-tight font-bold text-foreground md:text-4xl">
            No access.
          </p>
          <p className="mb-4 text-lg font-light text-muted-foreground">
            You don&#39;t have permission to view this page. Ask an admin to
            grant you access to this app.
          </p>
          {action && <div className="mb-4 flex flex-col items-center gap-2">{action}</div>}
          <Button asChild variant={action ? "outline" : "default"}>
            <Link to="/">Back to Homepage</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Page403;
